var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFlagOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#002B2B",
  d: "M9.4 2 9 0H0v17h2v-7h5.6l.4 2h7V2zm3.6 8H9.64l-.4-2H2V2h5.36l.4 2H13z"
})));
export { SvgFlagOutline as ReactComponent };
export default __webpack_public_path__ + "5615c2010dc4523a5ca27285b35e4266.svg";